import { connect } from 'react-redux'

import PrivateRoute from './PrivateRoute'

const mapStateToProps = (state) => {
  return {
    user: state.user.user
  }
}

export default connect(mapStateToProps, null)(PrivateRoute)
